import { render, staticRenderFns } from "./ModalDescontoAdicional.vue?vue&type=template&id=5520fd6c"
import script from "./ModalDescontoAdicional.vue?vue&type=script&lang=js"
export * from "./ModalDescontoAdicional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports